import { useCallback } from 'react';
import Modal from 'utils/packages/Modal';
import { formatDiscount } from '../utils';
const strings = {
    title: 'Are you sure?',
    confirmButtonTitle: 'Yes, skip the deal',
};
const useDismissOfferModal = () => {
    const dismissOfferModal = useCallback((onContinueCallback, onCancelCallback, productName, percentOff, savingPerYear) => {
        const formattedPercentOff = percentOff > 1 ? percentOff : formatDiscount(percentOff);
        const subtitle = `This ${productName} offer is about to expire — get ${productName} for ${formattedPercentOff}% off today and save ${savingPerYear} a year. Once it’s gone, it’s gone.`;
        const cancelButtonTitle = `No, claim my ${formattedPercentOff}% off`;
        Modal.showConfirmation({
            title: strings.title,
            subtitle,
            confirmButtonTitle: strings.confirmButtonTitle,
            cancelButtonTitle,
            onConfirm: () => {
                Modal.hide();
                onCancelCallback();
            },
            onPressCancel: onContinueCallback,
        });
    }, []);
    return {
        dismissOfferModal,
    };
};
export default useDismissOfferModal;
